import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ts_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-73e050a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "custom_bar navbar-dark sticky-top shadow p-0",
  style: {"background-color":"rgba(19,169,232,1)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { style: {"width":"75%"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("技术产品")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("个人中心")
const _hoisted_7 = {
  key: 0,
  class: "list-inline",
  style: {"margin-right":"2rem","margin-top":".5125rem","padding-top":".3125rem"}
}
const _hoisted_8 = { class: "list-inline-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_10 = { class: "list-inline-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("注册")
const _hoisted_12 = {
  key: 1,
  class: "list-inline mb-0"
}
const _hoisted_13 = { class: "list-inline-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "custom_bar col-1 me-0 px-3",
      style: {"margin-left":"3rem","width":"10%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "text",
            size: "medium",
            style: {"color":"#ffffff","margin-right":"3rem","font-size":"large"}
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/specs" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "text",
            style: {"color":"#ffffff","margin-right":"3rem","font-size":"large"}
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.user.isLogin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/home"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                style: {"color":"#ffffff","font-size":"large"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (!_ctx.user.isLogin)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/login",
                class: "btn btn-outline-dark"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/signUp",
                class: "btn btn-outline-dark"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_12, [
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_dropdown, {
                title: `hi ${_ctx.user.username}`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_dropdown_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                      }, "退出登录")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ])
          ]))
    ])
  ]))
}